import { EnumSchema } from '../metadata-schema';

export const Plaatsingstatus: EnumSchema = {
	"type": "string",
	"title": "Plaatsingstatus",
	"enum": [
		"Definitief",
		"Voorlopig"
	]
};
